// KatalogyView — jednotná stránka s tabs pre všetky katalógy (ústava 58.1, 3029)
// Tabs: PLU (skladové) · CP položky · Požičovňa · Dodávateľský (budúce) · Vlastné (budúce)
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useBreadcrumb } from '../components/Layout.jsx'
import { Tabs } from '../components/Ui.jsx'
import { COLORS, SPACE } from '../theme.js'
import PluCatalogView from './PluCatalogView.jsx'
import CpKatalogView from './CpKatalogView.jsx'
import PozicovnaView from './PozicovnaView.jsx'
import TechPostupyView from './TechPostupyView.jsx'

export default function KatalogyView() {
  const navigate = useNavigate()
  const location = useLocation()
  const { setTrail } = useBreadcrumb()

  // Tab podľa URL
  const initial = location.pathname.includes('/cp')   ? 'cp'
               : location.pathname.includes('/pozicovna')   ? 'pozicovna'
               : location.pathname.includes('/tech-postupy') ? 'tp'
               : location.pathname.includes('/dodavatelia') ? 'dodavatelia'
               : location.pathname.includes('/vlastne')     ? 'vlastne'
               : 'plu'
  const [tab, setTab] = useState(initial)

  useEffect(() => {
    setTrail([{ label: 'Matrix v2' }, { label: 'Katalógy' }])
    return () => setTrail([])
  }, [setTrail])

  function changeTab(k) {
    setTab(k)
    const map = { plu: '/katalog/plu', cp: '/katalog/cp', pozicovna: '/katalog/pozicovna', tp: '/katalog/tech-postupy', dodavatelia: '/katalog/dodavatelia', vlastne: '/katalog/vlastne' }
    if (map[k] && location.pathname !== map[k]) navigate(map[k], { replace: true })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <div style={{ padding: `0 ${SPACE.md}px`, borderBottom: `1px solid ${COLORS.line}`, background: COLORS.bg }}>
        <Tabs value={tab} onChange={changeTab} tabs={[
          { key: 'plu',         label: 'PLU (skladové)' },
          { key: 'cp',          label: 'CP položky' },
          { key: 'pozicovna',   label: 'Požičovňa' },
          { key: 'tp',          label: 'Tech. postupy' },
          { key: 'dodavatelia', label: 'Dodávateľský', active: false },
          { key: 'vlastne',     label: 'Vlastné položky', active: false },
        ]} />
      </div>
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {tab === 'plu' && <PluCatalogView />}
        {tab === 'cp'  && <CpKatalogView />}
        {tab === 'pozicovna' && (
          <div style={{ flex: 1, minHeight: 0, padding: SPACE.md, overflow: 'auto' }}>
            <PozicovnaView katalog />
          </div>
        )}
        {tab === 'tp' && <TechPostupyView />}
      </div>
    </div>
  )
}
